const ArrowLine = () => {
    return (
        <svg width="61" height="13" viewBox="0 0 61 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M60.7697 6.5001L54.9 0.630371L49.0303 6.5001L54.9 12.3698L60.7697 6.5001ZM0 7.51677H54.9V5.48343H0V7.51677Z" fill="url(#paint0_linear_2457_14712)" />
            <defs>
                <linearGradient id="paint0_linear_2457_14712" x1="4.575" y1="10.0584" x2="9.28874" y2="21.327" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#65A7A0" stopOpacity="0" />
                    <stop offset="1" stopColor="#6FB3AB" />
                </linearGradient>
            </defs>
        </svg>

    )
}

export default ArrowLine;